"use client";

import React from "react";
import EditSection, { TextEditor, ListItemEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function CollegeStatsEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  const defaultStats = [
    { value: "50,000+", label: "Students Graduated" },
    { value: "500+", label: "Industry Partners" },
    { value: "95%", label: "Placement Rate" },
    { value: "200+", label: "Expert Faculty" },
  ];

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Headers</h4>
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Our Impact"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Statistics List</h4>
            <ListItemEditor
              label="Stats"
              items={content.stats || defaultStats}
              itemSchema={[
                { key: "value", label: "Value", type: "text" },
                { key: "label", label: "Label / Metric", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, stats: items })}
              addItemText="Add Stat"
            />
          </div>
        </div>
      }
    />
  );
}
